/**
 * Generate 1–2 letter avatar text from a name.
 *
 * - If the name has 2 or more words → Use the first letter of the first two words (e.g., "DT Support Main" → "DS").
 * - If the name is a single word:
 *    - If it's only 1 character long → Return that character uppercase.
 *    - Otherwise → Return first 2 characters uppercase (e.g., "Doubletick" → "DO").
 */
export function getAvatarText(name: string): string {
  if (!name) return "";

  const trimmed = name.trim().replace(/\s+/g, " ");
  const words = trimmed.split(" ");

  // If 2+ words -> use first letter of first two words
  if (words.length >= 2) {
    return words
      .slice(0, 2)
      .map(w => w[0]?.toUpperCase())
      .join("");
  }

  // Single word case
  const word = words[0];

  if (word.length === 1) {
    return word.toUpperCase();
  }

  return word.substring(0, 2).toUpperCase();
}
